const SAVED_USERNAME_LOCAL_STORAGE_KEY = "marlin-saved-username";

export const getLocalSavedUsername = (): string | null => {
  return localStorage.getItem(SAVED_USERNAME_LOCAL_STORAGE_KEY);
}

export const setLocalSavedUsername = (username: string) => {
  localStorage.setItem(SAVED_USERNAME_LOCAL_STORAGE_KEY, username);
}

export const resetLocalSavedUsername = () => {
  localStorage.removeItem(SAVED_USERNAME_LOCAL_STORAGE_KEY);
}